import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Card, Avatar, Typography } from "antd";
import dayjs from "dayjs";
import useGetApi from "../../services/useGetApi";

const { Text } = Typography;

const ChatCard = forwardRef(({ chat }, ref) => {
  const [isGetMessagesLoading, getMessagesError, messages, getMessages] =
    useGetApi(`messages/chat`, [], true);

  const fetchMessages = () => {
    if (chat && chat.messageThreadCode) {
      getMessages(`messages/chat?messagethreadcode=${chat.messageThreadCode}`);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [chat]);

  // Scroll to bottom whenever messages update
  useEffect(() => {
    if (chatContainerRef.current) {
      if (messages.length > 0) {
        setTimeout(() => {
          chatContainerRef.current?.scrollTo({
            top: chatContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }, 100);
      }
    }
  }, [messages]);

  // Expose refreshChat function to parent
  useImperativeHandle(ref, () => ({
    refreshChat: fetchMessages,
  }));

  const chatContainerRef = useRef(null);

  return (
    <Card className="chat-card">
      <div
        style={{
          height: "400px", // Ensure it's fixed
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
        ref={chatContainerRef}
        className="chat-container"
      >
        {messages &&
          messages.map((msg, index) => {
            const isSender = msg.receiver == chat.recipient.id;
            return (
              <div
                key={index}
                className={`chat-message ${isSender ? "sent" : "received"}`}
              >
                {!isSender && (
                  <Avatar size="small" className="chat-avatar">
                    {`${chat.recipient.firstName
                      .charAt(0)
                      .toUpperCase()}${chat.recipient.lastName
                      .charAt(0)
                      .toUpperCase()}`}
                  </Avatar>
                )}

                <div
                  className={`chat-bubble ${
                    isSender ? "sent-bubble" : "received-bubble"
                  }`}
                >
                  <Text
                    className="chat-text"
                    style={isSender ? { color: "#fff" } : {}}
                  >
                    {msg.message}
                  </Text>
                  <Text
                    type="secondary"
                    className="chat-timestamp"
                    style={isSender ? { color: "#fff" } : {}}
                  >
                    {dayjs(msg.timestamp).format("DD-MM-YYYY , h:mm A")}
                  </Text>
                </div>

                {isSender && (
                  <Avatar size="small" className="chat-avatar me-avatar">
                    Me
                  </Avatar>
                )}
              </div>
            );
          })}
      </div>
    </Card>
  );
});

export default ChatCard;
